import { createFileRoute } from '@tanstack/react-router'
import { AssetTypesPage } from '../../../components/AssetTypesPage'

export const Route = createFileRoute('/$org/asset-types/')({
  component: AssetTypes,
  validateSearch: (search: Record<string, unknown>) => ({
    q: (search.q as string) || undefined,
    page: (search.page as string) || undefined,
    // Spec 2026-10-09-04: the tree view and its mode live in the URL.
    view: search.view === 'tree' ? ('tree' as const) : undefined,
    tree: search.tree === 'children' ? ('children' as const) : undefined,
  }),
})

function AssetTypes() {
  return <AssetTypesPage />
}
